
import { store } from 'src/App'
import { selectors as environmentSelectors } from 'store/environment'

const generateUrl = <T>(url: string, params: T): string => {
  if (params !== null) {
    Object.getOwnPropertyNames(params).forEach(key => {
      url = url.replace('{' + key + '}', params[key])
    })
  }

  return environmentSelectors.getBaseUrl(store.getState()) + url
}

export default generateUrl



// WEBPACK FOOTER //
// ./src/network/generate-url.ts